import { render, staticRenderFns } from "./AteConfig.vue?vue&type=template&id=951a4300&scoped=true"
import script from "./AteConfig.vue?vue&type=script&lang=js"
export * from "./AteConfig.vue?vue&type=script&lang=js"
import style0 from "./AteConfig.vue?vue&type=style&index=0&id=951a4300&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "951a4300",
  null
  
)

export default component.exports